import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircleTwoTone';

const styles = theme => ({
  root: theme.buttonTypes != null ? {
    color: theme.buttonTypes.create.backgroundColor,
    '&:hover': {
      color: theme.buttonTypes.create['&:hover'].backgroundColor,
    },
  } : {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});

const YesCircleIcon = (props) => {
  const { disabled, classes, ...others } = props;

  if (disabled) {
    return <CheckCircle color="disabled" {...others} />;
  }

  return <CheckCircle classes={{ root: classes.root }} {...others} />;
};

YesCircleIcon.defaultProps = {
  disabled: false,
};

YesCircleIcon.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
};


export default withStyles(styles)(YesCircleIcon);
